/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Each_Group_Must_Have_At_Least_One_ItemInputs */



/**
* | output |
* | --- |
* | "Each group must have at least one item" |
*
* @param {Each_Group_Must_Have_At_Least_One_ItemInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const each_group_must_have_at_least_one_item = /** @type {((inputs?: Each_Group_Must_Have_At_Least_One_ItemInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Each_Group_Must_Have_At_Least_One_ItemInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Each group must have at least one item")
	return /** @type {LocalizedString} */ ("Chaque groupe doit avoir au moins un élément")
});